'use strict';

import { module } from '../../app';

module.factory('scarDrawer', [
  'mathHelper',
  function (mathHelper) {
    return function (paper, target, cb) {
      let enabled = false;

      let path, ptdata, lastPoint;

      let paperWidth = 800;
      let paperHeight = 350;

      let line = d3.svg.line()
                   .interpolate("linear")
                   .x(function (d, i) {
                     return d[ 0 ];
                   })
                   .y(function (d, i) {
                     return d[ 1 ];
                   });

      this.enable = function (value) {
        enabled = value;
        if (!value) {
          path = null;
          ptdata = null;
          lastPoint = null;
        }

        // make sure prevent scrolling during drawing scar
        setTimeout(() => {
          //console.log('disable scrolling');

          document.ontouchmove = function (e) {
            e.preventDefault();
            return false;
          };
        }, 500);
      };

      let drawScar = d3.behavior.drag()
                       .origin(d => d)
                       .on("dragstart", scarDragStart)
                       .on("drag", scarDragMove)
                       .on("dragend", scarDragEnd);

      target
        .datum({})
        .call(drawScar);

      var lastEvent = null;

      function scarDragStart(d) {
        if (!enabled) {
          return;
        }

        lastEvent = 'start';

        // if after 300ms no move event happen, then release the memory at this step so the red line would not show up
        setTimeout(() => {
          if (lastEvent === 'start') {
            lastEvent = null;
            draw(null);
          }
        }, 300);

        //console.log('drag start');
        let m = d3.mouse(this);
        draw(m);

        function draw(m) {
          lastPoint = m;
          ptdata = m ? [ m ] : [];
          path = paper
            .append("path")
            .data([ ptdata ])
            .attr("class", "line")
            .attr("d", line)
            .attr('fill', 'none')
            .attr('stroke', 'red')
            .attr('stroke-width', 2);
        }
      }

      function scarDragMove(d) {
        if (!enabled) {
          return;
        }

        if (lastEvent !== 'move') {
          lastEvent = 'move';
          return;
        }

        let m = d3.mouse(this);
        if (!m || !lastPoint || m[ 1 ] < 0 || m[ 0 ] < 0 || m[ 0 ] > paperWidth || m[ 1 ] > paperHeight)
          return;

        //console.log('drag move', JSON.stringify(m));

        let maxDist = 25;
        if (mathHelper.lineDistance(m, lastPoint) > maxDist) {
          if (ptdata.length > 1) {
            let perpLine = mathHelper.getPerpendicular(m, lastPoint, 10);
            ptdata.push(perpLine[ 0 ], perpLine[ 1 ], lastPoint, m);
          } else {
            ptdata.push(m);
          }
          lastPoint = m;
        } else {
          // ptdata.push(m);
        }
        path
          .attr("d", d => line(d));
      }

      function scarDragEnd(d) {
        if (!enabled || !lastPoint) {
          return;
        }
        lastEvent = null;

        //console.log('drag end');

        let minX = mathHelper.min(ptdata.map(p => p[ 0 ]));
        let minY = mathHelper.min(ptdata.map(p => p[ 1 ]));

        let maxX = mathHelper.max(ptdata.map(p => p[ 0 ]));
        let maxY = mathHelper.max(ptdata.map(p => p[ 1 ]));
        let width = maxX - minX;
        let height = maxY - minY;

        let records = ptdata.map(p => [ p[ 0 ] - minX - width / 2, p[ 1 ] - minY - height / 2 ]);

        let result = {
          x: minX + width / 2,
          y: minY + height / 2,
          width: maxX - minX,
          height: maxY - minY,
          path: records
        };

        path.remove();
        cb(result);
      }

    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/services/svg/scarDrawer.js